module.exports = __webpack_public_path__ + "static/media/menu-proposals-white.a3b58a60.svg";